module.exports = __webpack_public_path__ + "static/samloyd_portfolio_wrapped-7fb1537cdb29e590e034b4133a8317e3.png";